import OrderSummary from './components';

export default {
  path: '/order/:orderId',
  key: '/order/',
  exact: true,
  component: OrderSummary,
};
